import { useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../api/api";

function AddPatient() {
  const navigate = useNavigate();

  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");

  // DOB / Age
  const [dob, setDob] = useState("");
  const [ageYears, setAgeYears] = useState("");
  const [ageMonths, setAgeMonths] = useState("");

  const [symptoms, setSymptoms] = useState("");
  const [saving, setSaving] = useState(false);

  const handleSave = async () => {
    if (!name || !phone) {
      alert("Name and phone are required");
      return;
    }

    if (!dob && ageYears === "") {
      alert("Please enter DOB or Age");
      return;
    }

    try {
      setSaving(true);

      const payload = {
        name,
        phone,
        problem_text: symptoms,
      };

      if (dob) {
        payload.dob = dob;
      } else {
        payload.initial_age_years = Number(ageYears);
        payload.initial_age_months = Number(ageMonths || 0);
      }

      await api.post("/api/patients", payload);

      navigate("/");
    } catch (err) {
      console.error(err);
      alert("Failed to add patient");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="min-h-screen pb-20 bg-gray-100 px-4 py-4">
      <button
        onClick={() => navigate(-1)}
        className="text-blue-600 mb-4"
      >
        ← Back
      </button>

      <h1 className="text-xl font-semibold mb-4">
        Add Patient
      </h1>

      {/* Name */}
      <input
        className="w-full h-11 px-3 mb-3 border rounded-lg"
        placeholder="Patient Name"
        value={name}
        onChange={(e) => setName(e.target.value)}
      />

      {/* Phone */}
      <input
        className="w-full h-11 px-3 mb-3 border rounded-lg"
        placeholder="Phone Number"
        value={phone}
        onChange={(e) => setPhone(e.target.value)}
      />

      {/* DOB */}
      <label className="block text-sm font-medium mb-1">
        Date of Birth (preferred)
      </label>
      <input
        type="date"
        className="w-full h-11 px-3 mb-3 border rounded-lg"
        value={dob}
        onChange={(e) => setDob(e.target.value)}
      />

      {/* OR Divider */}
      <div className="text-center text-sm text-gray-500 mb-2">
        OR enter age
      </div>

      {/* Age */}
      <div className="flex gap-3 mb-3">
        <input
          type="number"
          className="w-1/2 h-11 px-3 border rounded-lg"
          placeholder="Years"
          value={ageYears}
          onChange={(e) => setAgeYears(e.target.value)}
        />
        <input
          type="number"
          className="w-1/2 h-11 px-3 border rounded-lg"
          placeholder="Months"
          value={ageMonths}
          onChange={(e) => setAgeMonths(e.target.value)}
        />
      </div>

      {/* Symptoms */}
      <textarea
        className="w-full p-3 mb-4 border rounded-lg"
        rows={4}
        placeholder="Illness / Symptoms"
        value={symptoms}
        onChange={(e) => setSymptoms(e.target.value)}
      />

      {/* Save */}
      <button
        onClick={handleSave}
        disabled={saving}
        className="
          w-full
          h-12
          bg-blue-600
          text-white
          rounded-xl
          font-medium
          active:bg-blue-700
        "
      >
        {saving ? "Saving..." : "Save Patient"}
      </button>
    </div>
  );
}

export default AddPatient;
